import { purpurBreakpointMd } from '@purpur/library/tokens';
import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

import { MenuItemIcon, MenuItemNamedIcon, StyledMenuItem } from '../MenuItem/MenuItem.styles';

export const MessagesIconWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export const MessagesCount = styled.div`
    position: absolute;
    transform: translate(-50%, -50%);
    width: 1rem;
    height: 1rem;
    font-size: 0.625rem;
    color: ${getPurpurColor('functionalWhite')};
    background-color: ${getPurpurColor('red500')};
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const MessagesLink = styled(StyledMenuItem)`
    @media screen and (max-width: calc(${purpurBreakpointMd} - 1px)) {
        flex-direction: column;
        justify-content: center;
        gap: 0;
        font-size: ${getPurpurTypography('scale75')};

        ${MenuItemIcon},
        ${MenuItemNamedIcon} {
            width: ${getPurpurSpacing('300')};
            height: ${getPurpurSpacing('300')};
            margin-top: 0.375rem;
            margin-bottom: 0.375rem;
        }

        ${MessagesCount} {
            top: 0.75rem;
        }
    }
`;
